import React from 'react';
import ErrorPage from '@/components/ErrorPage';
import { IconButton } from 'rsuite';
import ArrowLeftLine from '@rsuite/icons/ArrowLeftLine';

export default () => (
  <ErrorPage code={503}>
    <p className="error-page-title">Work In Progress...</p>
    <p className="error-page-subtitle text-muted ">This page is being updating and maintainance.</p>
    <IconButton icon={<ArrowLeftLine />} appearance="primary" href="/dashboard">
      Take me home
    </IconButton>
  </ErrorPage>
);
